import BookingTicket from './BookingTicket';

export default BookingTicket;
